export class assetBlockItemExtendedData {
  constructor(
    public assets: broadcastBlockAssetItem[] = [],
    public broadcastAssetItems: {
      [key: string]: broadcastAssetItemExtendedData;
    } = {},
  ) {}

  public getBroadcastAssetItem(uid: string): broadcastAssetItemExtendedData {
    if (!this.broadcastAssetItems[uid]) {
      this.broadcastAssetItems[uid] = broadcastAssetItemExtendedData.create();
    }
    return this.broadcastAssetItems[uid];
  }
}
export interface AssetGroupEntry {
  label: string;
  colorIndex: number;
  endAssetId?: string;
}

export class broadcastAssetItemExtendedData {
  constructor(
    public stackIndex: number,
    public stackLength: number,
    public assetsVisibility: { [key: string]: boolean },
    public assetsAsPlayedLog: broadcastBlockAssetItemAsPlayedLog[],
    public assetsControlBaseLayerVolume: { [key: string]: number },
    public assetsOrder: {
      [key: string]: number;
    },
    public assetsHideChannelLogo: { [key: string]: boolean },
    public assetGroups: { [assetId: string]: AssetGroupEntry } = {},
  ) {}
  public static create() {
    return new broadcastAssetItemExtendedData(0, 0, {}, [], {}, {}, {}, {});
  }
}
export class broadcastBlockBaseAssetItem {
  constructor(
    public id: string,
    public duration: number,
  ) {}
}

export class broadcastBlockAssetItem extends broadcastBlockBaseAssetItem {
  constructor(
    public id: string,
    public name: string,
    public duration: number,
    public thumbnail: string,
  ) {
    super(id, duration);
  }
}

export class broadcastBlockAssetItemAsPlayedLog extends broadcastBlockBaseAssetItem {
  constructor(
    public id: string,
    public duration: number,
    public airTimestamp: number,
  ) {
    super(id, duration);
  }
}
